import { render } from "./PlanDetailsModal.vue?vue&type=template&id=770976fa&scoped=true"
import script from "./PlanDetailsModal.vue?vue&type=script&lang=js"
export * from "./PlanDetailsModal.vue?vue&type=script&lang=js"

import "./PlanDetailsModal.vue?vue&type=style&index=0&id=770976fa&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770976fa"]])

export default __exports__